import { modules } from '../constants';
import Api from '../helpers/Api';

const { payment } = modules;

export const paymentModule = {
  namespaced: true,
  state: {
    servicesBill: [],
    paySets: [],
  },
  actions: {
    async getServicesBill({ commit, rootState }, id) {
      const data = { ...rootState.user.constantParams };
      data.Name_module = payment;
      data.Name_event = 'GET:services_bill';
      data.id_patient = id;
      const result = await Api.get(data);
      if (result) {
        commit('SERVICES_BILL', result);
        return result.body;
      }
      return false;
    },
    async getMyPySets({ commit, rootState }, id) {
      console.log(id);
      const data = { ...rootState.user.constantParams };
      data.Name_module = payment;
      data.Name_event = 'GET:my_pay_sets';
      data.id_patient = id;
      const result = await Api.get(data);
      if (result) {
        commit('MY_PAY_SETS', result);
        return result.body;
      }
      return false;
    },
    async getNewPaySet({ dispatch, rootState }, context) {
      const data = { ...rootState.user.constantParams };
      data.Name_module = payment;
      data.Name_event = 'GET:new_pay_set';
      data.id_patient = context.id_patient;
      data.sum_pay = context.sum_pay;
      data.id_bill_list = context.id_bill_list;
      const result = await Api.get(data);
      if (result) {
        await dispatch('getMyPySets', context.id_patient);
      }
      return false;
    },

    async delPaySet({ dispatch, rootState }, context) {
      const data = { ...rootState.user.constantParams };
      data.Name_module = payment;
      data.Name_event = 'POST:QR_del';
      data.id_pay_set = context.id_pay_set;
      const result = await Api.post(data);
      console.log('pay set deleted');
      await dispatch('getMyPySets', context.id_patient);
      await dispatch('getServicesBill', context.id_patient);
    },
    async refound({ dispatch, rootState }, context) {
      const data = { ...rootState.user.constantParams };
      data.Name_module = payment;
      data.Name_event = 'POST:refounds';
      data.id_pay_set = context.id_pay_set;
      const result = await Api.post(data);
      await dispatch('getMyPySets', context.id_patient);
      await dispatch('getServicesBill', context.id_patient);
    },
  },
  mutations: {
    SERVICES_BILL(state, payload) {
      state.servicesBill = payload.body;
      state.servicesBill = state.servicesBill.map((i) => ({ ...i, checked: false }));
    },
    UPDATE_SERRVICES_BILL(state, payload) {
      state.servicesBill = payload;
    },
    MY_PAY_SETS(state, payload) {
      state.paySets = payload.body;
    },
  },
  getters: {},
};
